import React from 'react'
import FinancialReportShell from '../components/FinancialReportShell'
import FinancialLotteryReportList from '../components/FinancialLotteryReportList'

const FinancialReportPage: React.FC = () => {
  return (
    <FinancialReportShell activeTab="all">
      <FinancialLotteryReportList mode="all" />
    </FinancialReportShell>
  )
}

export default FinancialReportPage
